// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HealthCheckForm from './HealthCheckForm';
import AdminDashboard from './AdminDashboard';
import Mypage from './Mypage';
import ReservationByLocation from './ReservationByLocation';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* ユーザー向けフォーム */}
        <Route
          path="/"
          element={
            <div
              style={{
                position: 'relative',
                minHeight: '100vh',
                overflow: 'auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '40px', // 上下余白
                boxSizing: 'border-box',
              }}
            >
              <div
                style={{
                  backgroundImage: "url('/hospital.jpg')",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundAttachment: "scroll",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  opacity: 0.5,
                  zIndex: -1,
                }}
              />
              <div
                style={{
                  zIndex: 1,
                  background: 'rgba(255, 255, 255, 0.95)',
                  padding: '30px',
                  borderRadius: '10px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
                  maxWidth: '600px',
                  width: '100%',
                }}
              >
                <HealthCheckForm />
              </div>
            </div>
          }
        />

        {/* 管理者用ダッシュボード */}
        <Route
          path="/admin"
          element={
            <div style={{ position: 'relative', minHeight: '100vh', overflow: 'auto' }}>
              <div
                style={{
                  backgroundImage: "url('/hospital.jpg')",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundAttachment: "scroll",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  opacity: 0.5,
                  zIndex: -1,
                }}
              />
              <div style={{ position: 'relative', zIndex: 1, padding: '20px' }}>
                <AdminDashboard />
              </div>
            </div>
          }
        />

        {/* ユーザー自身の確認ページ（マイページ） */}
        <Route
          path="/mypage"
          element={
            <div style={{ position: 'relative', minHeight: '100vh', overflow: 'auto' }}>
              <div
                style={{
                  backgroundImage: "url('/hospital.jpg')",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundAttachment: "scroll",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  opacity: 0.5,
                  zIndex: -1,
                }}
              />
              <div style={{ position: 'relative', zIndex: 1, padding: '20px' }}>
                <Mypage />
              </div>
            </div>
          }
        />

        {/* 新規：病院別予約状況ページ */}
        <Route
          path="/reservations"
          element={
            <div style={{ position: 'relative', minHeight: '100vh', overflow: 'auto' }}>
              <div
                style={{
                  backgroundImage: "url('/hospital.jpg')",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundAttachment: "scroll",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  opacity: 0.5,
                  zIndex: -1,
                }}
              />
              <div style={{ position: 'relative', zIndex: 1, padding: '20px' }}>
                <ReservationByLocation />
              </div>
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
